/**
 * Small layout-hint card shown at the top of each per-layout form.
 *
 * Purely advisory — the editor doesn't enforce the convention. Useful
 * for engineers building a deck for the first time who don't yet have
 * the slide-library in their head.
 */

import type { ReactNode } from "react";

interface LayoutHintProps {
  title: string;
  children: ReactNode;
}

export function LayoutHint({ title, children }: LayoutHintProps) {
  return (
    <div style={style} data-testid="layout-hint">
      <strong style={{ display: "block", marginBottom: "0.2em" }}>
        {title}
      </strong>
      <div style={{ color: "var(--gray-11)", fontSize: "0.85em" }}>
        {children}
      </div>
    </div>
  );
}

const style: React.CSSProperties = {
  padding: "0.55rem 0.75rem",
  marginBottom: "0.75rem",
  background: "var(--gray-3)",
  border: "1px solid var(--gray-5)",
  borderRadius: 4,
  fontSize: "0.85em",
};
